import { render, staticRenderFns } from "./alertsauto.vue?vue&type=template&id=62a248e4&"
import script from "./alertsauto.vue?vue&type=script&lang=js&"
export * from "./alertsauto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports